import React, { useRef, useState } from 'react';

import { addDotsWithNullIfNeeded, formatAmount } from '../../../../helpers/currency.helper';
import { CURRENCY, FORMAT_TYPE, TOOLTIP_MAX_LETTRES } from '../../../../constants/general';
import TooltipWithTriangle from '../../../../generic-components/TooltipWithTriangle';
import Icon from '../../../../generic-components/Icon';

interface IProps {
  name: string;
  transactionAmount: string;
  isRejected?: boolean;
  iconSrc?: string;
}

const TransactionNameAndAmount = ({ name, transactionAmount, isRejected, iconSrc }: IProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const isNumberPositive = parseFloat(transactionAmount) > 0;
  const companyNameRef = useRef<HTMLParagraphElement | null>(null);

  const isEllipsis = () =>
    companyNameRef.current && companyNameRef.current?.offsetWidth < companyNameRef.current.scrollWidth;

  return (
    <>
      {showTooltip && (
        <TooltipWithTriangle
          tooltipContainerClassName='absolute flex flex-col justify-center items-center min-h-[48px] top-[34px] right-[36px]'
          tooltipContentClassName='text-sm text-bw00 flex flex-col justify-center items-center rounded bg-bw08 px-3 py-2 text-sm tablet:w-[220px] pc-sm:w-[287px] min-h-[48px]'
        >
          <p>{name}</p>
        </TooltipWithTriangle>
      )}
      <div className='flex justify-between items-center w-full font-metricMedium text-base relative'>
        <div
          id='transactionDetailsCompanyName'
          className={`w-[65%] h-full ${name?.length > TOOLTIP_MAX_LETTRES || isEllipsis() ? 'cursor-pointer' : ''}`}
          onMouseEnter={() => {
            if (name?.length > TOOLTIP_MAX_LETTRES || isEllipsis()) {
              setShowTooltip(true);
            }
          }}
          onMouseLeave={() => {
            if (name?.length > TOOLTIP_MAX_LETTRES || isEllipsis()) {
              setShowTooltip(false);
            }
          }}
        >
          <div className='flex items-center gap-[6px]'>
            {iconSrc && <Icon iconId='trxHeaderIcon' className='w-[22px]' src={iconSrc} />}
            <p ref={companyNameRef} className='overflow-hidden whitespace-nowrap text-ellipsis ' id='test'>
              {name}
            </p>
          </div>
        </div>
        <div
          className={isRejected ? 'text-bw06' : isNumberPositive ? 'text-badgeGreen03' : ''}
          id='transactionDetailsAmount'
        >
          {formatAmount(addDotsWithNullIfNeeded(transactionAmount), FORMAT_TYPE.FORMATTED, CURRENCY.USD.SYMBOL, true)}
        </div>
      </div>
    </>
  );
};
export default TransactionNameAndAmount;
